module.exports = __webpack_public_path__ + "static/img-grammar-school-c19495773311e9976b91e367bf25a488.png";